module.exports = __webpack_public_path__ + "images/FUSA_icons/066-shopping-bag-1.a160d4f94afcfa9b74742668e932a8ca.svg";